import React from 'react';
const HeroSection = () => {
  return <section className="bg-[#c19a3c] pt-16 pb-20 px-6 md:px-12 flex flex-col items-center" data-id="element-72">
      <h1 className="text-white text-4xl md:text-6xl lg:text-7xl text-center font-serif mb-12" data-id="element-73">
        Birthing Leaders. Building Legacy
      </h1>
      <div className="w-full max-w-md" data-id="element-74">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m3yvFs3xjE5TYx2XsSbMb4/MLF_Logo.png" alt="Maverick Legacy Foundation Logo" className="w-full" data-id="element-75" />
      </div>
    </section>;
};
export default HeroSection;